import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Register from "./components/Register";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import ProtectedRoute from "./ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";

import HomePage from "./components/HomePage";
import FirstPage from "./components/FirstPage";
import Coursepage from "./components/Coursepage";
import { SourceProvider } from "./context/SourceContext";
import Contact from "./components/Contact";
import OutputComp from "./components/OutputCompt";
import ContentPage from "./components/ContentPage";
import VideoPlayer from "./components/VideoPlayer";

import AddCategory from "./admin/AddCategory";
import AddCourse from "./admin/AddCourse";
import AddSubject from "./admin/AddSubject";
import AddTopic from "./admin/AddTopic";
import Userinfo from "./admin/Userinfo";

const App = () => (
  <SourceProvider>
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<FirstPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />

          {/* Admin Routes */}
          <Route path="/admin/add-category" element={<ProtectedRoute><AddCategory /></ProtectedRoute>} />
          <Route path="/admin/add-course" element={<ProtectedRoute><AddCourse /></ProtectedRoute>} />
          <Route path="/admin/add-subject" element={<ProtectedRoute><AddSubject /></ProtectedRoute>} />
          <Route path="/admin/add-topic" element={<ProtectedRoute><AddTopic /></ProtectedRoute>} />

          {/* Protected Routes */}
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/:page"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/usersinfo"
            element={
              <ProtectedRoute>
                <Userinfo />
              </ProtectedRoute>
            }
          />

          {/* Dynamically load category page */}
          <Route
            path="/:category"
            element={
              <ProtectedRoute>
                <Coursepage />
              </ProtectedRoute>
            }
          />

          {/* Course page */}
          <Route
            path="/:category/:courseName"
            element={
              <ProtectedRoute>
                <OutputComp />
              </ProtectedRoute>
            }
          />

          {/* Subject page */}
          <Route
            path="/:category/:courseName/:subjectName"
            element={
              <ProtectedRoute>
                <ContentPage />
              </ProtectedRoute>
            }
          />

          {/* Topic / Video page */}
          <Route
            path="/:category/:courseName/:subjectName/:topicName"
            element={
              <ProtectedRoute>
                <VideoPlayer />
              </ProtectedRoute>
            }
          />

          {/* Contact */}
          <Route
            path="/contact"
            element={
              <ProtectedRoute>
                <Contact />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  </SourceProvider>
);

export default App;
